import React, { Component } from 'react'
import { withRouter } from 'react-router-dom'
import { connect } from 'react-redux'
import { compose, bindActionCreators } from 'redux'
import moment from 'moment'
import cookie from 'react-cookies'

import ShoppingListScreen from './ShoppingListScreen.tsx'
import {
  getUserDailyBalance,
  addMealToCart,
  removeMealFromCart,
  getCartItems,
  checkMealInCart,
} from '../../../Api/dietApi/userInfo'

class ShoppingListScreenContainer extends Component {
  state = {
    todayDate: moment().format('YYYY-MM-DD'),
    chosenDate: this.props.match.params.chosenDate
      ? this.props.match.params.chosenDate
      : null,
    daysAdded: 0,
    cart: [],
    isDemoAccount: cookie.load('userDemoMode'),
    challengeMode: this.props.location.challengeMode
  }

  changeDiet = () => {
    this.props.history.push({
      pathname: '/dieta/wybierz-diete/',
      userChangeDiet: true,
    })
  }

  componentDidMount = () => {
    this.getUserDiet()
    this.formatDate()
    this.getUserCart(
      this.state.chosenDate ? this.state.chosenDate : this.state.todayDate
    )
  }

  formatDate = () => {
    this.setState({
      formattedDate: moment(
        this.state.chosenDate ? this.state.chosenDate : this.state.todayDate
      ).format('dddd, DD MMMM'),
      notFormattedDate: this.state.chosenDate
        ? this.state.chosenDate
        : this.state.todayDate,
    })
  }

  getUserDiet = async () => {
    const userBalance = await getUserDailyBalance(moment().format('YYYY-MM-DD'))

    if (userBalance) {
      this.setState({
        diet: userBalance.diet,
      })
    }
  }

  getUserCart = async (date) => {
    const items = await getCartItems(date)

    this.setState({
      cartItems: items,
    })
  }

  addItemToCart = (mealId, date) => {
    addMealToCart(mealId, date)
  }

  removeItemFromCart = async (mealId) => {
    await removeMealFromCart(mealId)
    await this.getUserCart(
      this.state.selectedDate
        ? this.state.selectedDate
        : moment().format('YYYY-MM-DD')
    )
  }

  selectNextDay = async () => {
    let date = await moment(this.state.notFormattedDate)
    let date2 = await moment(this.state.notFormattedDate)

    await this.setState({
      daysAdded: ++this.state.daysAdded,
    })
    let newDateNotFormatted = await date2.add(this.state.daysAdded, 'days')
    let newDate = await date.add(this.state.daysAdded, 'days')

    await this.setState({
      formattedDate: newDate.format('dddd, DD MMMM'),
      newPickedDateNotFormatted: newDateNotFormatted.format('YYYY-MM-DD'),
    })

    await this.getUserCart(this.state.newPickedDateNotFormatted)
  }

  selectPrevDay = async () => {
    let date = await moment(this.state.notFormattedDate)
    let date2 = await moment(this.state.notFormattedDate)

    await this.setState({
      daysAdded: --this.state.daysAdded,
    })
    let newDateNotFormatted = await date2.add(this.state.daysAdded, 'days')
    let newDate = await date.add(this.state.daysAdded, 'days')

    await this.setState({
      formattedDate: newDate.format('dddd, DD MMMM'),
      newPickedDateNotFormatted: newDateNotFormatted.format('YYYY-MM-DD'),
    })

    await this.getUserCart(this.state.newPickedDateNotFormatted)
  }

  checkItem = async (mealId) => {
    await checkMealInCart(mealId)
    await this.getUserCart(
      this.state.selectedDate
        ? this.state.selectedDate
        : moment().format('YYYY-MM-DD')
    )
  }

  render() {
    return (
      <ShoppingListScreen
        diet={this.state.diet}
        dietCart={this.state.cartItems}
        formattedDate={this.state.formattedDate}
        selectPrevDay={this.selectPrevDay}
        selectNextDay={this.selectNextDay}
        removeItemFromCart={this.removeItemFromCart}
        checkItem={this.checkItem}
        changeDiet={this.changeDiet}
        isDemoAccount={this.state.isDemoAccount}
        challengeMode={this.state.challengeMode}
      />
    )
  }
}

function mapStateToProps(state) {
  return {
    user: state.user,
    diet: state.diet,
  }
}

// function mapDispatchToProps(dispatch) {
//   return {
//     dietActions: bindActionCreators(dietActions, dispatch),
//   }
// }

export default compose(
  withRouter,
  connect(mapStateToProps)
)(ShoppingListScreenContainer)
